import AxiosClient from "../../../services/axios.services";

class CasualtyMonitorServices {
  getCasualtyMonitor = (params) =>
    AxiosClient.get("/api/app/Monitor_bajas/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  // saveCasualtyMonitor = (data) =>
  //   AxiosClient.post("/api/app/sanciones_monitor_bajas/", data, {
  //     headers: { "Content-Type": "application/json" },
  //   });
  workflowAssign = (id, data) =>
    AxiosClient.put(
      `/api/app/Monitor_bajas/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  // deleteCasualtyMonitor = (id) =>
  //   AxiosClient.delete(`/api/app/sanciones_monitor_bajas/${id}`, {
  //     headers: { "Content-Type": "application/json" },
  //   });
}

export default new CasualtyMonitorServices();
